import { BasePaymentMethodsClient } from "@core/types";
import { PaymentMethod, PaymentMethodIdEnum } from "@core/types";

class PaymentMethodsClient extends BasePaymentMethodsClient {
  async getPaymentMethods() {
    const data: PaymentMethod[] = [
      {
        id: "1",
        title: "Наличными при получении",
        type: PaymentMethodIdEnum.cash,
        enabled: true,
      },
      {
        id: "2",
        title: "Онлайн",
        type: PaymentMethodIdEnum.card,
        enabled: true,
      },
    ];
    return data;
  }
}

export default PaymentMethodsClient;
